import React from 'react';
import { Disclosure as HeadlessUIDisclosure } from '@headlessui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { useFormikContext } from 'formik';

import useAutoAnimate from '@dashboard/hooks/useAutoAnimate';

import { Field, renderFields } from '../Form';

export default function Disclosure({ fields, label, inputClassName }) {
  const animate = useAutoAnimate();
  const { values, setFieldValue } = useFormikContext();

  if (!fields) return null;

  return (
    <div>
      <HeadlessUIDisclosure ref={animate} as="div">
        <HeadlessUIDisclosure.Button className="flex items-center gap-x-1 text-gray-900 hover:text-gray-500 font-medium text-sm transition-colors">
          {({ open }) => (
            <>
              <div className="flex-1 text-left">{label}</div>
              {open ? (
                <ChevronUpIcon className="w-4 h-4" />
              ) : (
                <ChevronDownIcon className="w-4 h-4" />
              )}
            </>
          )}
        </HeadlessUIDisclosure.Button>

        <HeadlessUIDisclosure.Panel className="mt-4">
          {renderFields({ fields, values, setFieldValue }).map(field => (
            <Field
              key={field.name}
              field={{
                ...field,
                visible: field.visible === undefined ? true : field.visible,
              }}
              values={values}
              inputClassName={inputClassName}
            />
          ))}
        </HeadlessUIDisclosure.Panel>
      </HeadlessUIDisclosure>
    </div>
  );
}
